import React from "react";

function Header() {
  return (
    <header className="tc-inner-header-style1">
      <div className="container">
        <div className="info col-lg-7">
          <h1 className="js-title"> Catalog </h1>
          <div className="text fsz-18 color-666">
            Architecture is a visual art, and the building <br /> speak for
            themselves
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
